// extracted by mini-css-extract-plugin
export default {"modal_wrap":"basicMoadal_modal_wrap__FTwkI","content":"basicMoadal_content__oSnnD","footer":"basicMoadal_footer__oa-va"};